import { absolutePath } from "../absolutePath";

export const communityMembers = {
  show: (id: number) => absolutePath(`access_registry/community_members/${id}`),
  accessGroup: (communityMemberId: number, accessGroupId: number) =>
    absolutePath(
      `access_registry/community_members/${communityMemberId}/access_groups/${accessGroupId}`,
    ),
  grant: (id: number) =>
    absolutePath(`access_registry/community_members/${id}/grant`),
  revoke: (id: number) =>
    absolutePath(`access_registry/community_members/${id}/revoke`),
  history: (communityMemberId: number) =>
    absolutePath(
      `access_registry/community_members/${communityMemberId}/history`,
    ),
  // Backend route added in a later slice (PAY-2455).
  timeline: (communityMemberId: number, accessGroupId: number) =>
    absolutePath(
      `access_registry/community_members/${communityMemberId}/access_groups/${accessGroupId}/timeline`,
    ),
  // Backend route added in a later slice (PAY-2453).
  grants: (communityMemberId: number, accessGroupId: number) =>
    absolutePath(
      `access_registry/community_members/${communityMemberId}/access_groups/${accessGroupId}/grants`,
    ),
  reconnectSpaces: (communityMemberId: number, accessGroupId: number) =>
    absolutePath(
      `access_registry/community_members/${communityMemberId}/access_groups/${accessGroupId}/reconnect_spaces`,
    ),
};
